<template>
  <ul class="widget w-faved-page">
    <li v-for="member in lessThan18" :key="member.id">
      <router-link
        :to="`/s-app/profile-page/${member.sUserId}`"
        class="d-flex h-100"
      >
        <SUserAvatar
          :myUser="member.sUser"
          size="small"
          :isProfileAvatar="false"
          :tryModeratorBadge="true"
        />
      </router-link>
      <md-tooltip md-direction="bottom">{{
        getUserName(member.sUser)
      }}</md-tooltip>
    </li>

    <li
      v-if="getCurrentGroupMembers.length > 18"
      class="all-users"
      data-toggle="tooltip"
      data-placement="top"
      data-original-title="See all the members of this group"
    >
      <router-link :to="{ name: 'GroupsMembership' }" class="members-img">
        +{{ getCurrentGroupMembers.length - 18 }}
      </router-link>
    </li>
  </ul>
</template>

<script>
import GroupHelperVue from "../../mixins/GroupHelper.vue";
import UserHelperVue from "../../mixins/UserHelper.vue";
import SUserAvatar from "@/material-components/atoms/SUserAvatar";
export default {
  name: "MemebersHolder",
  mixins: [GroupHelperVue, UserHelperVue],
  components: {
    SUserAvatar,
  },
  computed: {
    lessThan18() {
      if (this.getCurrentGroupMembers.length > 18) {
        return this.getCurrentGroupMembers.slice(0, 18);
      }
      return this.getCurrentGroupMembers;
    },
  },
};
</script>

<style lang="scss" scoped>
img {
  max-width: 34px;
  max-height: 34px;
}
.avatar-container {
  margin-right: 10px;
  position: relative;
}
.w-faved-page {
  margin: 0 !important;
}
.w-faved-page li {
  width: unset;
  height: unset;
}
</style>
